const SRC = "https://checkout.razorpay.com/v1/checkout.js";

const load = () =>
  new Promise((resolve, reject) => {
    if (window.Razorpay) return resolve();
    const s = document.createElement("script");
    s.src = SRC;
    s.onload = resolve;
    s.onerror = () => reject(new Error("Could not load the payment window. Check your internet and try again."));
    document.body.appendChild(s);
  });

export async function openCheckout(order, { name, description }) {
  await load();
  return new Promise((resolve, reject) => {
    const rz = new window.Razorpay({
      key: order.key_id,
      amount: order.amount,
      currency: order.currency,
      order_id: order.order_id,
      name,
      description,
      prefill: order.prefill,
      theme: { color: "#F59E0B" },
      handler: resolve,
      modal: { ondismiss: () => reject(new Error("Payment cancelled")) },
    });
    rz.on("payment.failed", (r) => reject(new Error(r?.error?.description || "Payment failed")));
    rz.open();
  });
}
